/**
 * [Utils]: methods and objects that contain reusable functionality and can be called on demand.
 */

import Modules from './born.modules'; 

export const globalWrapper = document.querySelector('#wrapper');

export const breakpoints = {
	mobile: 768,
	tablet: 1024,
	site: 1280
};

export const isMobile = {
	Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

export const isRTL = document.documentElement.getAttribute('dir') === 'rtl' ? true : false;

export const dwJSPath = 'cartridges/app_modist_core/cartridge/js/';

export const progress = {
	loader: null,
	show: function(container) {
		var $target = (!container || $(container).length === 0) ? BORN.$body : $(container);

		this.loader = $target.find('.ajax-loader');

		if (!this.loader.length) {
			this.loader = $('<div/>').addClass('ajax-loader');
			$target.append(this.loader);
		}

		this.loader.fadeIn(250);
	},
	hide: function() {
		if (this.loader) {
			this.loader.fadeOut(250);
		}
	}
};

/**
 * add attribute to an html element to scroll to part of the page
 * @param  [string 'target selector'| object {target, offset }] options
 *
 * Usage: <a data-jumpto='{"target": '.header', "offset": 200}'>jump</a>
 */
export function jumpTo (options) {
    // check if options was passed as an object string
    try {
        options = JSON.parse(options);
    }

    catch (e) {
        // string with target was passed.. hopefully
    }

    //Do nothing if this option is on, which means the source element has the 
    //'toggle--active' class on.
    if(options.ignoreOnToggle && !this.classList.contains('toggle--active')) {
		return;
    }

    // pull options keys or set defaults
    let $target = (options.target) ? $(options.target) : $(options),
        offset = isNaN(options.offset) && document.querySelector(options.offset) ? document.querySelector(options.offset).getBoundingClientRect().height
 : (options.offset || 0),
		targetOffsetTop = $target.offset().top - offset;
    
    // scroll mofo
	$('body, html').animate({
		scrollTop: targetOffsetTop
	}, 500);
}

export function allowedNumInput (evt) {
	var upDownArrows   = evt.keyCode === 38 || evt.keyCode === 40,
		leftRightArows = evt.keyCode === 37 || evt.keyCode === 39,
		allowEnter     = evt.keyCode === 13,
		allowedKeys    = (evt.keyCode > 47 && evt.keyCode < 58) || allowEnter || upDownArrows || leftRightArows || evt.metaKey || evt.ctrlKet || evt.altKey || evt.keyCode === 8 || evt.keyCode === 9,
		allowPeriod    = allowedKeys || evt.keyCode === 190;

	return {
		'upDown':         upDownArrows,
		'leftRightArows': leftRightArows,
		'allowed':        allowedKeys,
		'allowPeriod':    allowPeriod
	};
}

export function info (test) {
	console.log('Utils: ' + test);
}
/**
 * [Returns the selected filter count in mobile]
 */
 export function getSelectedFilterCount(){
    $(".refinement_filtercount--mob").each(function(){
        let selectedCount = $(this).closest('.refinement').find("a.refinement__link.checked").length;
        $(this).text((selectedCount > 0) ? selectedCount: "");
    });
}

/**
 * [Returns the transition event type supported by the browser]
 */
export function whichTransition () {
    var dummyEl = document.createElement('dummy'),
		transitions = {
			'transition':       'transitionend',
			'OTransition':      'oTransitionEnd',
			'MozTransition':    'transitionend',
			'WebkitTransition': 'webkitTransitionEnd'
		};

	for(var key in transitions){
		if( dummyEl.style[key] !== undefined ){
			return transitions[key];
		}
	}
}
/**
 * [Returns the selected filter labels in web view]
 */
 export function getSelectedfilterlabels() {
	$('.refinement_filtervalues').each(function(){
        const selectedEle = [];
        let $selectionArea = $(this).parents('.toggle__link').siblings('.toggle__content').find('.refinement__link.checked');
        if($selectionArea.length > 0){
            $selectionArea.each(function(){
                selectedEle.push($.trim($(this).immediateText()));
            });
            if(selectedEle.length > 0){
                let selectedElelabel = selectedEle.length > 2 ? (selectedEle[0] +", "+selectedEle[1] + " + " + (parseInt(selectedEle.length)-2) ): selectedEle.join(", ");
                $(this).html(selectedElelabel);
                $(this).attr('title',selectedEle.join(","));
            }
        }
    });
 }


/**
 * [Returns the default view in filter mobile]
 */
 export function setdefaultFilteractive($generic,$specific){
    $generic.removeClass('activefilter toggle--active');
    $generic.children('.toggle__content,.toggle__link').removeClass('toggle--active');
    $specific.addClass('activefilter');
    $specific.children('.toggle__content,.toggle__link').addClass('toggle--active');
}


/**
 * [createElWithAttrs creates an element with a set of given attributes passed as the 2nd parameter,
 * then appends the new element to the target parent passed on the 1st parameter]
 * @param  {[type]} appendTarget [description]
 * @param  {[type]} attributes   [description]
 *  @param {[type]} type        [description]
 * @return {[type]}              [description]
 */
export function createElWithAttrs (appendTarget, attributes, type) {
	let el = document.createElement(type || 'div');

	for(var key in attributes) {
		el.setAttribute(key, attributes[key]);
	}

	if(appendTarget) {
		appendTarget.appendChild(el);
	}

	return el;
}

/**
 * [toggleOverlay Initial overlay functionality.
 * This needs more work if we're implementing for random elements]
 * This is kinda shitty.
 * @param  {[type]} show   [description]
 * @param  {[type]} setOnHeader [description]
 * @return {[type]}        [description]
 */
export function toggleOverlay (show, setOnHeader, showOnMobile = true) {

	//Disable this functionality on mobile if required
	if( !showOnMobile && window.innerWidth < breakpoints.mobile ){
		return;
	}

	//For this project, the main nav needs to be position: fixed; so we insert the overlay in it cause transforms create a new context, this containing it.
	var overlayBody   = document.querySelector('.focus-overlay--body')   || createElWithAttrs(globalWrapper, {'class': 'focus-overlay focus-overlay--body'}),
		overlayHeader = document.querySelector('.focus-overlay--header') || createElWithAttrs(document.querySelector('.header__main'), {'class': 'focus-overlay focus-overlay--header'});

	if( show ){
		overlayBody.classList.add('set--active');
		overlayBody.classList.add('overlay--body--mob');
		
		if(setOnHeader) {
			overlayHeader.classList.add('set--active');
		}
		
		if(window.innerWidth < breakpoints.mobile) {
			overlayBody.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
			});
		}
	}

	else{
		overlayBody.classList.remove('set--active');
		overlayHeader.classList.remove('set--active');
		overlayBody.classList.remove('overlay--body--mob');
	}
}

/**
 * [Creates a message banner that can be displayed either on top or bottom of the viewport]
 * @param  {[type]} message  [description]
 * @param  {[type]} wrapper  [description]
 * @param  {[type]} position [description]
 * @return {[type]}          [description]
 */
export function createMessageBanner (message, wrapper, position) {
	let container 		= wrapper || document.body,
		bannerID		= 'notif-banner--' + new Date().getTime(),
		banner 			= createElWithAttrs(container, {id: bannerID, class: 'notif-banner notif-banner--' + (position || 'bottom')}),
		bannerContents 	= createElWithAttrs(banner, {class: 'notif-banner__center max-width--site gutter-padding--full'}),
		bannerTrigger 	= createElWithAttrs(bannerContents, {class: 'notif-banner__trigger', 'data-toggle-target': '#' + bannerID, 'data-toggle-immediate': true}, 'span'),
		bannerCopy 		= createElWithAttrs(bannerContents, {class: 'notif-banner__message p3'}, 'p'),
		bannerCancel	= createElWithAttrs(bannerContents, {class: 'notif-banner__action icon--cancel link txt--upper', 'data-toggle-close': true}, 'span');

	bannerCopy.textContent = message || 'Complete';
	bannerCancel.textContent = window.Resources.CLOSE;

	Modules.toggle.init('#' + bannerID + ' .notif-banner__trigger');
	// banner.showContent();
}

/**
 * [createCookie creates a cookie]
 * @param  {[string]} name  [cookie name]
 * @param  {[string]} value [cookie description]
 * @param  {[int]} days  [amount of days the cookie must be alive for]
 */
export function createCookie(name, value, days) {
	var expires;

	if (days) {
		let date = new Date();

		date.setTime(date.getTime() + ( days * 24 * 60 * 60 * 1000));
		expires = '; expires=' + date.toGMTString();
	}

	else {
		expires = '';
	}

	document.cookie = name + '=' + value + expires + '; path=/';
}

/**
 * [readCookie tries to find a cookie with the provided name]
 * @param  {[string]} name [cookie name]
 * @return {[string]}      [string containing the searched cookie, if any]
 */
export function readCookie(name) {
	var nameEQ = name + '=',
		cookieList = document.cookie.split(';');

	for(var i = 0; i < cookieList.length; i++) {
		let currentCookie = cookieList[i];

		while(currentCookie.charAt(0) == ' ') {
			currentCookie = currentCookie.substring(1,currentCookie.length);
		}

		if (currentCookie.indexOf(nameEQ) === 0) {
			return currentCookie.substring(nameEQ.length, currentCookie.length);
		} 
	}

	return null;
}

/**
 * [eraseCookie]
 * @param  {[string]} name [cookie name that needs to be erased]
 */
export function eraseCookie(name) {
    createCookie(name, '', -1);
}

export function shouldEnableSticky(){
    var wrapperH        = document.querySelector('#wrapper').getBoundingClientRect().height,
        excludedPages   = document.querySelector('.pt_checkout, .pt_order-confirmation, .pt_azdesigners, .pt_account, .pt_wishlist, .pt_order'),
        isNotMobile     = window.innerWidth >= breakpoints.mobile,
        isPLP           = document.querySelector('.pt_product-search-result'),
        compareHeight   = isPLP ? 1350 : 1400,
        shouldntEnable  = isNotMobile && (excludedPages || wrapperH <= compareHeight);

    if( shouldntEnable ) {
        return false;
    }

    return true;
}

/*Remove empty category refinement element*/
export function checkTypeRefinement() {
    var categoryRefinement = $('#categoryRefinement');
    if(categoryRefinement && categoryRefinement.length > 0) {
        var subCatEl = categoryRefinement.find('ul li');
        if(subCatEl && subCatEl.length > 0) {
            categoryRefinement.show();
        } else {
            categoryRefinement.remove();
            if(window.innerWidth < breakpoints.mobile ) {
                var allRefinementEl = $('.refinement__all__toggle');
                if(allRefinementEl && allRefinementEl.find('.activefilter').length <= 0) {
                    var filtersRefinementEl = allRefinementEl.find('.refinement');
                    if(filtersRefinementEl && filtersRefinementEl.length > 0) {
                        var firstEl = $(filtersRefinementEl[0]).find('.toggle__link');
                        if(firstEl && firstEl.length > 0 ) {
                            firstEl.trigger('click');
                        }
                    }
                }   
            }
        }
    }
}

/*Show/Hide Chat widget*/
export function toggleChatWidget(hide)
{
    if(window.innerWidth < breakpoints.mobile) {
        if(checkChatWidget()) {
            zE(function() {
                if(hide) {
                    zE.show();
                } else {
                    zE.hide();
                }
            });
        }
    }
}

export function checkChatWidget()
{
    if(typeof zE !== 'undefined' && !!zE) {
        return true;
    }
    return false;
}

export function initReplaceContent(el)
{
    replaceContent(el);
    $(window).on('resize', function () {
        replaceContent(el);
    });
}

function replaceContent(el)
{
    if(el === undefined || !el) {
        return;
    }
    var webContent = $(el+'-web');
    var mobileContent = $(el+'-mob');
    if (window.innerWidth <= breakpoints.mobile) {
        if (mobileContent.length >0 && webContent.length > 0) {
            if(mobileContent.children().length >0) {
                return;
            }
            var content = webContent.children();
            if(content.length <=0) {
                return;
            }
            mobileContent.html("");
            mobileContent.html(content.clone());
        }
    } 
}

export function initCartCloseButton() {
    if (window.innerWidth <= breakpoints.mobile) {
        $(".cart-back-cta").on('click', function () {
            var url = getPageUrlHistory();
            if (url && url != '') {
                window.location.href = url;
            } else {
                window.history.back();
            }

        });
    }
}

function getPageUrlHistory()
{
    return localStorage.getItem("pageurlhistory");
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/born.utils.js